import React, { useState, useEffect } from "react";
import {
  Button,
  Flex,
  Input,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItem,
  Skeleton,
} from "@chakra-ui/react";
import { EllipsisVertical, Rocket } from "lucide-react";
import { useAppContext } from "../contexts/AppContext";
import OnboardingFundTable from "../components/funds/Onboarding/OnboardingFundTable";

const Onboarding = ({ onOpen }) => {
  const { onboardingData, tableSize, toggleTableSize } = useAppContext();
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Loading state

  useEffect(() => {
    // Set filteredData when the context data becomes available
    if (onboardingData.length > 0) {
      setFilteredData(onboardingData);
      setIsLoading(false); // Stop loading when data is available
    }
  }, [onboardingData]);


  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = onboardingData.filter((fund) => {
      const matchesSearch = fund.fundName.toLowerCase().includes(query);
      return matchesSearch;
    });

    setFilteredData(filtered);
  };

  return (

      <Flex direction="column" p={0} w={"100%"} gap={8}>
      <Flex justifyContent="space-between" direction={{ lg: "row", base: "column" }} gap={4}>
      <h1>Onboarding</h1>
      <Button w={"fit-content"} leftIcon={<Rocket size={16} />} onClick={() => onOpen("onboardingProcess")}>
          Start onboarding
      </Button>
        </Flex>

        <Flex gap={2}>
          <Input
            type="text"
            size="lg"
            placeholder="Search funds by name..."
            value={searchQuery}
            onChange={handleSearch}
          />

<Menu>
            <MenuButton
              as={IconButton}
              icon={<EllipsisVertical size={20} />}
              size={"lg"}
              variant="outline"
            />
            <MenuList>
            <MenuOptionGroup defaultValue="asc" title="Actions" type="radio">
              <MenuItem onClick={() => alert("Export as CSV clicked")}>
                Export as CSV
              </MenuItem>
              <MenuItem onClick={() => alert("Export as PDF clicked")}>
                Export as PDF
              </MenuItem>
              <MenuItem onClick={() => alert("Generate Report clicked")}>
                Generate report
              </MenuItem>
          </MenuOptionGroup>
          <MenuOptionGroup defaultValue="asc" title="Display" type="radio">
              <MenuItem onClick={toggleTableSize}>
              {tableSize === "sm" ? "Expand view" : "Compact view"}
              </MenuItem>
          </MenuOptionGroup>

            </MenuList>
          </Menu>
        </Flex>

        

        {isLoading ? (
          <Flex justifyContent="center" alignItems="center" w={"100%"} flex={1} direction={"column"} gap={4}>
            <Skeleton minHeight='42px' w={'100%'} borderRadius={8} />
            <Skeleton minHeight='42px' w={'100%'} borderRadius={8} />
            <Skeleton minHeight='42px' w={'100%'} borderRadius={8} />
            <Skeleton minHeight='42px' w={'100%'} borderRadius={8} />
            <Skeleton minHeight='42px' w={'100%'} borderRadius={8} />
            <Skeleton minHeight='42px' w={'100%'} borderRadius={8} />
            <Skeleton minHeight='42px' w={'100%'} borderRadius={8} />
            <Skeleton minHeight='42px' w={'100%'} borderRadius={8} />
            <Skeleton minHeight='42px' w={'100%'} borderRadius={8} />
            <Skeleton minHeight='42px' w={'100%'} borderRadius={8} />
            <Skeleton minHeight='42px' w={'100%'} borderRadius={8} />
          </Flex>
        ) : (
          <OnboardingFundTable data={filteredData} />
        )}
      </Flex>
  );
};

export default Onboarding;
